import { render, staticRenderFns } from "./showcase.vue?vue&type=template&id=23d73648&scoped=true&"
import script from "./showcase.vue?vue&type=script&lang=js&"
export * from "./showcase.vue?vue&type=script&lang=js&"
import style0 from "./showcase.vue?vue&type=style&index=0&id=23d73648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d73648",
  null
  
)

export default component.exports